@if (gallery()) {
  @if (!subPage()) {
    <div class="main-page" [@mainPage]>
      <div class="header">
        <h1>Design</h1>
        @if (isDev) {
          <div class="buttons">
            <button (click)="copyJson()" appButton name="DONTREPORT" height="0" size="0" shape="round">Export</button>
            <button (click)="importJson()" appButton name="DONTREPORT" height="0" size="0" shape="round">Import</button>
          </div>
        }
      </div>

      <app-gallery-settings-group title="Theme" location="gallery-theme-menu" [noContentPadding]="true" [beta]="true">
        <app-theme-select-item [gallery]="gallery()" (customize)="subPage.set('theme')"></app-theme-select-item>
      </app-gallery-settings-group>

      <app-gallery-settings-group title="Customize" location="gallery-theme-menu" [noContentPadding]="true">
        <app-theme-cover-item (customize)="subPage.set('cover')"></app-theme-cover-item>
        <app-theme-layout-item [gallery]="gallery()" (customize)="subPage.set('layout')"></app-theme-layout-item>
        <app-theme-asset-page-item
          [gallery]="gallery()"
          (customize)="subPage.set('asset-page')"
        ></app-theme-asset-page-item>
        <app-theme-typography-item
          [gallery]="gallery()"
          (customize)="subPage.set('typography')"
        ></app-theme-typography-item>
        <app-theme-colors-item [gallery]="gallery()" (customize)="subPage.set('colors')"></app-theme-colors-item>
      </app-gallery-settings-group>

      @if (themeIsCustom()) {
        <button
          class="save-theme"
          appButton
          name="save"
          location="gallery-theme-menu"
          color="simple-primary"
          shape="round"
          height="1"
          [center]="true"
          (click)="saveTheme()"
        >
          <span>Save Theme</span>
          <app-upgrade-badge scope="gallery:themes" location="gallery-theme-menu"></app-upgrade-badge>
        </button>
      }

      <div class="feedback">
        <p>
          Do you have feedback or suggestions?
          <a class="primary-link" [routerLink]="['/a/features']">Contact us</a>
        </p>
      </div>
    </div>
  } @else {
    <div class="sub-page" [@subPage]>
      @if (subPage() === 'theme') {
        <app-theme-select-customize [gallery]="gallery()" (back)="subPage.set(null)"></app-theme-select-customize>
      } @else if (subPage() === 'typography') {
        <app-theme-typography-customize
          [gallery]="gallery()"
          [defaultOpenTypographyMenu]="defaultOpenTypographyMenu()"
          (back)="subPage.set(null)"
        ></app-theme-typography-customize>
      } @else if (subPage() === 'layout') {
        <app-theme-layout-customize [gallery]="gallery()" (back)="subPage.set(null)"></app-theme-layout-customize>
      } @else if (subPage() === 'colors') {
        <app-theme-colors-customize [gallery]="gallery()" (back)="subPage.set(null)"></app-theme-colors-customize>
      } @else if (subPage() === 'asset-page') {
        <app-theme-asset-page-customize
          [gallery]="gallery()"
          (back)="subPage.set(null)"
        ></app-theme-asset-page-customize>
      } @else if (subPage() === 'cover') {
        <app-theme-cover-customize [gallery]="gallery()" (back)="subPage.set(null)"></app-theme-cover-customize>
      }
    </div>
  }
}
